module.exports = __webpack_public_path__ + "assets/select2.aee2c07c.svg";